import React from "react";
import { Button, CalendarDate, Grid01, List, Mail01, MessageSquare01, Tabs } from "@opendate-app/setlist";

import { useBroadcastEditContext } from "./BroadcastEditContainer";

const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap",
    marginTop: 24,
    borderRadius: 12,
    boxShadow: "var(--sl-shadow-sm)",
    overflow: "hidden",
  },
  nav: {
    flex: "1 1 248px",
    padding: 24,
    backgroundColor: "var(--sl-bg-active)",
  },
  title: {
    color: "var(--sl-text-primary)",
    fontSize: 20,
    fontWeight: 600,
    marginBottom: 24,
  },
  content: {
    flex: "999 1 320px",
    minWidth: 0,
    padding: 24,
    backgroundColor: "var(--sl-bg-primary)",
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 8,
    marginTop: 48,
  },
};

export const StepFooter = ({ onBack, onNext }) => (
  <div style={styles.footer}>
    <Button variant="link-color" onClick={onBack}>Back</Button>
    <Button variant="primary" onClick={onNext}>Next</Button>
  </div>
);

const BroadcastSidebar = ({
  children
}) => {
  const {
    tab,
    setTab,
    isEmailTemplate,
  } = useBroadcastEditContext();

  const steps = [
    { value: "recipients", label: "Recipients", icon: List },
    ...(isEmailTemplate ? [
      { value: "from", label: "From", icon: Mail01 },
      { value: "content-select", label: "Content", icon: Grid01 },
    ] : [
      { value: "twilio-content", label: "Content", icon: MessageSquare01 },
    ]),
    { value: "review-and-schedule", label: "Review & Schedule", icon: CalendarDate },
  ];

  return (
    <div style={styles.container}>
      <nav style={styles.nav} aria-label="Broadcast steps">
        <div style={styles.title}>
          {isEmailTemplate ? "Email Broadcast" : "SMS Broadcast"}
        </div>
        <Tabs
          orientation="vertical"
          variant="button-gray"
          collapseBelow={0}
          value={tab}
          onChange={setTab}
          items={steps}
        />
      </nav>
      <div style={styles.content}>
        {children}
      </div>
    </div>
  );
};

export default BroadcastSidebar;
